import { LazyLoadComponent } from '@src/components';
import { FormSkeleton } from '@src/components/Loading/FormSkeleton';
import { DASHBOARD_URL } from '@src/constants/URLS.const';
import { selectProfile } from '@src/store/profile/profileSlice';
import { lazy, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const AffiliatePage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Affiliate,
  }))
);

export function AffiliateContainer() {
  const profile = useSelector(selectProfile);
  const navigate = useNavigate();

  useEffect(() => {
    if (!profile) {
      return;
    }

    if (!profile.isAffiliate) {
      navigate(DASHBOARD_URL);
    }
  }, [profile, navigate]);

  if (!profile) {
    return <FormSkeleton />;
  }

  return <LazyLoadComponent Component={<AffiliatePage />} />;
}
